import { ConfigurationPlan } from './configuration-plan';
import { v4 as uuidv4 } from 'uuid';

export class ConfigurationGroup {
  constructor(displayOrder: number, refId: string = uuidv4()) {
    this.id = refId;
    this.displayOrder = displayOrder;
    this.name = 'Groupe n° ' + displayOrder;
    this.workbenchConfigurationPlans = [];
  }

  id: string;
  name: string;
  displayOrder: number;
  numberOfAssembly: number;

  workbenchConfigurationPlans: ConfigurationPlan[];

  isValid() {
    return this.displayOrder != null && this.workbenchConfigurationPlans.length > 0;
  }
}
